import React from 'react'

function ProfileFlightUpcoming() {
  return (
    <div>ProfileFlightUpcoming</div>
  )
}

export default ProfileFlightUpcoming